import axiosInstance from "../../common/axios";

export function getPlanByIdAPI(planId) {
  return axiosInstance.get(`api/plan-details/${planId}`);
}

export function subscribeToPlanAPI(planId, values) {
    return axiosInstance.post(`api/subscribe-to-plan/${planId}/`, values);
  }